module.exports = __webpack_public_path__ + "static/media/can_logo_url_dark.88f99a5f.png";